/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { ViennaUser } from "@vienna/common";

import { GA_TAG } from "src/lib/config";

export const initGTag = (currentUser: ViennaUser): void => {
  window.gtag("config", GA_TAG, {
    send_page_view: false,
    user_id: currentUser.id,
  });
};
